/**
 * This is the public-api for your package. Export everything here that
 * you would like consumers to use.
 */
export const name = 'Creatomate';

// Components...
export { default as EditorSidebarButton } from './components/EditorSidebarButton';

// Contexts
export * as APIClientContext from './context/apiClient';
